import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { fetchEngagementLetterTemplate } from '../../store/investor/investorApiHelper';
import { closeEngagementLetter, setEngagementLetterData } from '../../store/investor/action';
import { TEXT_EDITOR_TYPES } from '../../store/investor/constants';
import { AICA_ENGAGEMENT_LETTER_PREVIEW, AICA_ENGAGEMENT_LETTER_SAVE } from '../../utils/constants/mixpanelEvents/investorEvents';
import DocumentContainer from '../DocumentEditor/DocumentContainer';

function EngagementLetter() {
    const dispatch = useAppDispatch();
    const engagementLetterData = useAppSelector((state) => state.investor.engagementLetter);

    return (
        <DocumentContainer
            orgId={engagementLetterData.orgId ?? ''}
            source={engagementLetterData.source ?? ''}
            loading={!!engagementLetterData.loading}
            companyName={engagementLetterData.companyName ?? ''}
            onUnmount={() => dispatch(closeEngagementLetter())}
            setLoading={(loading) => dispatch(setEngagementLetterData({ loading }))}
            onSaveComplete={() => dispatch(closeEngagementLetter())}
            fetchTemplate={fetchEngagementLetterTemplate}
            docType="ENGAGEMENT_LETTER"
            regenTitle="Engagement Letter"
            editorType={TEXT_EDITOR_TYPES.ENGAGEMENT_LETTER}
            documentType="engagementLetter"
            fileNamePrefix="Engagement_Letter"
            commentContainerId="el-comment-container"
            mixpanelPreviewEvent={AICA_ENGAGEMENT_LETTER_PREVIEW}
            mixpanelSaveEvent={AICA_ENGAGEMENT_LETTER_SAVE}
        />
    );
}

export default EngagementLetter;
